import { cn } from "@/utils/cn";
import { memo } from "react";

interface InfoIconProps {
  className?: string;
}

export const InfoIcon = memo(function InfoIcon({ className }: InfoIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("fill-os-brand", className)}
    >
      <path d="M11.7744 22.5488C5.87695 22.5488 1 17.6719 1 11.7744C1 5.86621 5.86621 1 11.7637 1C17.6719 1 22.5488 5.86621 22.5488 11.7744C22.5488 17.6719 17.6719 22.5488 11.7744 22.5488ZM11.7744 21.1523C16.9736 21.1523 21.1631 16.9629 21.1631 11.7744C21.1523 6.5752 16.9629 2.38574 11.7637 2.38574C6.5752 2.38574 2.39648 6.5752 2.39648 11.7744C2.39648 16.9629 6.5752 21.1523 11.7744 21.1523ZM11.71 7.72461C11.0547 7.72461 10.5283 7.20898 10.5283 6.55371C10.5283 5.89844 11.0547 5.37207 11.71 5.37207C12.376 5.37207 12.8916 5.89844 12.8916 6.55371C12.8916 7.20898 12.376 7.72461 11.71 7.72461ZM9.85156 17.6396C9.50781 17.6396 9.23926 17.3818 9.23926 17.0488C9.23926 16.7158 9.50781 16.4473 9.85156 16.4473H11.3984V10.8828H9.99121C9.64746 10.8828 9.37891 10.625 9.37891 10.2812C9.37891 9.95898 9.64746 9.69043 9.99121 9.69043H12.0645C12.4834 9.69043 12.709 9.99121 12.709 10.4316V16.4473H14.2559C14.5996 16.4473 14.8682 16.7158 14.8682 17.0488C14.8682 17.3818 14.5996 17.6396 14.2559 17.6396H9.85156Z" />
    </svg>
  );
});
